import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllWebsiteList(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/websites/`,
    oauthTokenHeader
  );
}

function getMetaRegions(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/regions/`, oauthTokenHeader);
}

function postWebsite(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/asset_management/websites/`,
    data,
    oauthTokenHeader
  );
}

function requestDomainIntegration(oauthTokenHeader: any, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/tasks/`,
    data,
    oauthTokenHeader
  );
}

function getDomainRequests(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/tasks/?type=Domain Request`,
    oauthTokenHeader
  );
}

function getSettingAttributes(
  oauthTokenHeader: string,
  website_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/websites/attributes/${website_shared_uid}/`,
    oauthTokenHeader
  );
}

function updateSettingsData(
  data: any,
  website_shared_uid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/websites/attributes/${website_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function updateEditSettingsData(
  data: any,
  website_shared_uid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/websites/${website_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function deactiveOrReactivate(
  data: any,
  website_shared_uid: string,
  oauthTokenHeader: any
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/websites/toggle/${website_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function isSyncEnable(
  data: any,
  website_shared_uid: string,
  oauthTokenHeader: any
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/websites/toggle/${website_shared_uid}/?sync=${data.sync}`,
    data,
    oauthTokenHeader
  );
}

function updateWebsiteURL(
  data: any,
  website_shared_uid: string,
  oauthTokenHeader: string
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/websites/url/${website_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}
export const websitesActionsService = {
  getAllWebsiteList,
  getSettingAttributes,
  updateSettingsData,
  updateEditSettingsData,
  isSyncEnable,
  deactiveOrReactivate,
  getMetaRegions,
  postWebsite,
  requestDomainIntegration,
  getDomainRequests,
  updateWebsiteURL,
};
